export const StoreState = {
    business:'business'
}

export const state = {
    [StoreState.business]:null
}
